export default {
  title: 'Bestellingen',
};
